import React from 'react';
import { DefaultView, DeleteAction, OptionalEditView, Views } from '../../types/BlockWithViews';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../components/organisms/BlockInteractions';
import { asFetchableBlock, useBlockContext, useRefreshBlock } from '../../_lib/BlockFetcher';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { Icons } from '../../components/atoms/SVG';
import { BlockType } from '../../types/api/ElementType';
import { PortalAvatarDefaultView } from './views/PortalAvatarDefaultView';
import { PortalAvatarEditView } from './views/PortalAvatarEditView';

type ProfileImageProps = Views<
  DefaultView<PortalAvatarDefaultView> & OptionalEditView<PortalAvatarEditView> & DeleteAction
>;
function PortalAvatar({ activeView = 'default', views }: ProfileImageProps) {
  const { t } = useSonTranslation('PortalAvatar');
  const { uuid, elementType } = useBlockContext();
  const { refresh, refreshCount } = useRefreshBlock();

  const buttons = {
    ...(views.edit &&
      createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        'PortalAvatar:edit',
        DISPLAY_TYPE.COLLAPSIBLE,
        <PortalAvatarEditView {...views.edit} />,
      )),
    ...(views.delete &&
      createButtonObject(BlockInteractionsViews.DELETE, Icons.ERASER, 'PortalAvatar:delete', DISPLAY_TYPE.MODAL)),
  };

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={elementType}
      headline={{ text: t('headline'), hierarchy: 2, visible: true }}
      views={views}
      activeView={activeView}
      buttons={buttons}
      alwaysShowInfo
      refreshBlock={refresh}
      refreshCount={refreshCount}
    >
      <PortalAvatarDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const PortalAvatarBlock = asFetchableBlock(PortalAvatar, BlockType.portalavatar);
